__turbopack_context__.v({
  "main": "SupportedControls-module__FR5tJa__main",
});
